import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ShopModalWrapper from '../shop-modal/ShopModalWrapper';
import CartErrorWarningModalWrapper from '../error-warning-modal/CartErrorWarningModalWrapper';
import ErrorWarningModalWrapper from '../error-warning-modal/ShopErrorWarningModalWrapper';
import NikeI18nProviderTranslations from '../i18n-react/i18n-provider';
import AddToCartModalWrapper from '../add-to-cart-modal/AddToCartModalWrapper';

const ShopApp = ({ errorsToExclude, shopInstance, warningsToInclude, queryClient }) => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <NikeI18nProviderTranslations>
          <Provider store={shopInstance.store}>
            <CartErrorWarningModalWrapper
              errorsToExclude={errorsToExclude}
              warningsToInclude={warningsToInclude}
            />
          </Provider>
          <Provider store={shopInstance.internalStore}>
            <>
              <ShopModalWrapper />
              <ErrorWarningModalWrapper errorsToExclude={errorsToExclude} />
              <AddToCartModalWrapper />
            </>
          </Provider>
          <div data-version={shopInstance?.version} />
          <ReactQueryDevtools initialIsOpen={false} />
        </NikeI18nProviderTranslations>
      </QueryClientProvider>
    </>
  );
};

ShopApp.propTypes = {
  shopInstance: PropTypes.shape({
    store: PropTypes.shape({}),
    internalStore: PropTypes.shape({}),
    version: PropTypes.string,
  }),
  language: PropTypes.string,
  errorsToExclude: PropTypes.arrayOf(PropTypes.string),
  warningsToInclude: PropTypes.arrayOf(PropTypes.string),
  queryClient: PropTypes.instanceOf(QueryClient),
};

export default ShopApp;
